import useJwt from '@/auth/jwt/useJwt'

/**
 * Return if user is logged in
 * This is completely up to you and how you want to store the token in your frontend application
 * e.g. If you are using cookies to store the application please update this function
 */
// eslint-disable-next-line arrow-body-style
export const isUserLoggedIn = () => {
  const token = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
  const userDataStr = localStorage.getItem('userData')
  
  // Verificar que existan token y userData
  if (!token || !userDataStr) {
    console.warn('⚠️ No hay token o userData - Usuario NO autenticado')
    // Limpiar cualquier dato residual
    if (token && !userDataStr) {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
    }
    if (!token && userDataStr) {
      localStorage.removeItem('userData')
    }
    return false
  }
  
  // Verificar que userData tenga la estructura correcta
  try {
    const userData = JSON.parse(userDataStr)
    const hasValidStructure = userData && 
                             userData.username && 
                             userData.role && 
                             userData.ability && 
                             Array.isArray(userData.ability) && 
                             userData.ability.length > 0
    
    if (!hasValidStructure) {
      console.warn('⚠️ userData tiene estructura inválida - Limpiando localStorage')
      // Limpiar datos inválidos
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem('userData')
      return false
    }
    
    console.log('✅ Usuario autenticado correctamente')
    return true
  } catch (e) {
    console.error('❌ Error al parsear userData - Limpiando localStorage:', e)
    // Limpiar datos corruptos
    localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
    localStorage.removeItem('userData')
    return false
  }
}

export const getUserData = () => {
  try {
    const userDataStr = localStorage.getItem('userData')
    return userDataStr ? JSON.parse(userDataStr) : null
  } catch (e) {
    console.error('Error al obtener userData:', e)
    return null
  }
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin' || userRole === 'administrador' || userRole === 'ADMIN') return { name: 'home' }
  if (userRole === 'coordinador') return { name: 'home' }
  if (userRole === 'consulta' || userRole === 'usuario') return { name: 'home' }
  if (userRole === 'client') return { name: 'access-control' }
  return { name: 'auth-login' }
}
